import { Node } from '@tiptap/core'

export enum ColumnLayout {
  SidebarLeft = 'sidebar-left',
  SidebarRight = 'sidebar-right',
  TwoColumn = 'two-column',
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    columns: {
      setColumns: () => ReturnType
      setLayout: (layout: ColumnLayout) => ReturnType
    }
  }
}

export const Columns = Node.create({
  name: 'columns',

  group: 'columns',

  content: 'column column',

  defining: true,

  isolating: true,

  addAttributes() {
    return {
      layout: {
        default: ColumnLayout.TwoColumn,
      },
    }
  },

  addCommands() {
    return {
      setColumns:
        () =>
          ({ commands }) =>
            commands.insertContent({
              type: this.name,
              content: [
                {
                  type: 'column',
                  attrs: {
                    position: 'left',
                  },
                  content: [
                    {
                      type: 'paragraph',
                    },
                  ],
                },
                {
                  type: 'column',
                  attrs: {
                    position: 'right',
                  },
                  content: [
                    {
                      type: 'paragraph',
                    },
                  ],
                },
              ],
            }
              //`<table data-type="columns"><tr><td data-type="column" data-position="left"><p></p></td><td data-type="column" data-position="right"><p></p></td></tr></table>`,
            ),
      setLayout:
        (layout: ColumnLayout) =>
          ({ commands }) =>
            commands.updateAttributes('columns', { layout }),
    }
  },

  renderHTML({ HTMLAttributes }) {
    return ['table', { 'data-type': 'columns', width: '100%', class: `layout-${HTMLAttributes.layout}` }, ['tr', {}, 0]]
  },

  parseHTML() {
    return [
      {
        tag: `table[data-type="${this.name}"]`,
      },
    ]
  },
})

export default Columns
